import { render } from "./Room.vue?vue&type=template&id=6769c5ca&ts=true&lang=pug"
import script from "./Room.vue?vue&type=script&lang=ts"
export * from "./Room.vue?vue&type=script&lang=ts"

import "./Room.vue?vue&type=style&index=0&id=6769c5ca&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__